import { AuthGuard } from "../../../shared/services";
import { CategoryAssociationsResolver } from "../associations-list/category-associations.resolver";
import { AssociationsDetailsComponent } from "./associations-details.component";
import { AssociationsDetailsResolver } from "./associations-details.resolver";
import { Route } from "@angular/router";
import { AssociationTypesResolver } from "./association-type.resolver";
import { OddsResolver } from "./odds.resolver";
import { RegionsResolver } from "./regions.resolver";

export const AssociationsDetailsRoutes: Route[] = [
  {
    path: "details/:id",
    component: AssociationsDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      association: AssociationsDetailsResolver,
      association_types: AssociationTypesResolver,
      categories: CategoryAssociationsResolver,
      odds: OddsResolver,
      regions: RegionsResolver,
    },
  },
];
